import { Box } from '@material-ui/core';
import { Typography } from '../..';
import React from 'react';
const FormSectionTitle = ({ children, ...rest }) => {
    return (React.createElement(Box, { mt: 4 },
        React.createElement(Typography, Object.assign({ variant: "subtitle1" }, rest), children)));
};
export default FormSectionTitle;
//# sourceMappingURL=FormSectionTitle.js.map